<script lang="tsx" setup>
import { mapState } from "../../context/context";
import { popTel } from "../../globalTeleport";
import ContentCenter from "../layout/ContentCenter.vue";
import IconPhone from "../icon/IconPhone.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { ContentCenter, IconPhone },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    phone: string;
  }>(),
  {}
);

const mappedState = mapState(["color.fontTertiaryReverse"]);
</script>

<template>
  <ContentCenter
    class="call-phone"
    direction="row"
    :style="{
      color: mappedState['color.fontTertiaryReverse'].value
    }"
    @click="() => popTel(props.phone)"
  >
    <div>
      <IconPhone></IconPhone>
    </div>
    <div>致电客服</div>
  </ContentCenter>
</template>

<style scoped>
.call-phone {
  cursor: pointer;
}
.call-phone > div:nth-child(1) {
  width: 24px;
  margin-right: var(--yz-gap-horizontal, 5px);
}
.call-phone > div:nth-child(2) {
  font-size: var(--yz-font-size-secondary, 14px);
}
</style>
